<template>
  <section class="card">
    <!-- <header class="card-header bg-info text-white">
      <div class="card-actions">
        <a href="#" class="card-action card-action-toggle" data-card-toggle=""></a>
      </div>
      <h2 class="card-title">{{$root.subTitle}}</h2>
    </header> -->
    <div class="card-body">
      <div class="mb-2">
        <router-link to="/users/create" class="btn btn-primary btn-sm">新增
          <i class="fa fa-plus"></i>
        </router-link>
      </div>
      <table class="table table-bordered table-hover table-striped mb-0">
        <thead class="table-dark ">
          <tr>
            <th>職稱</th>
            <!-- <th>帳號</th> -->
            <th>帳號</th> <!-- 2024.10.24 Email改為帳號 -->
            <th>最後登入時間</th>
            <th>建立時間</th>
            <th class="actions"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in rows" :key="item.id">
            <td>{{item.name}}</td>
            <!-- <td>{{item.userName}}</td> -->
            <td>{{item.email}}</td>
            <td>{{getTime(item.lastSigninTime)}}</td>
            <td>{{getTime(item.createTime)}}</td>
            <td class="actions">
              <router-link :to="{name:'/users/edit/:id', params:{id:item.id}}" class="on-default edit-row">
                <i class="fas fa-pencil-alt"></i>
              </router-link>
              <a class="on-default remove-row" @click="remove(item.id, i)">
                <i class="fas fa-trash-alt"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import moment from 'moment'
import { users } from "@/resource";
import { list } from "@/mixins";
import Utils from '../../utils/utils';

export default {
  mixins: [list],
  data() {
    return {
      resource: users
    };
  },
  methods: {
    getTime: function (timeString) {
      if (Utils.isEmptyObject(timeString)) {
        return '-'
      }
      return moment(timeString).format('YYYY/MM/DD HH:mm:ss')
    },
  },
};
</script>
<style scoped>
tbody > tr > td {width:100%;white-space:normal;word-wrap:break-word;word-break:break-all;} /* td自動斷行 */
table{table-layout:fixed;word-break:break-all;}  /* table不超過div */
</style>
